import React from "react";
import { FormattedMessage } from "react-intl";
import { EmailInput } from "src/shared/forms/inputs/EmailInputNew";

export const EMAIL = "email";

export interface IForgetPasswordFormData extends FormData {
  [EMAIL]: string;
}

export const ForgetPasswordForm = () => (
  <EmailInput
    inputID={EMAIL}
    label={<FormattedMessage id="form.email" />}
    isRequired
  />
);
